import React from 'react';
import styled, { css } from 'styled-components';
import Typography from '@material-ui/core/Typography';

import Loader from '../../../components/Loader';
import BarGraph from '../../../components/BarGraph';
import PieChart from '../../../components/PieChart';

class AttendanceVisualization extends React.Component {
  state = {
    graphsDataLoaded: false,
    graphsData: null,
  };

  componentDidMount() {
    this.loadGraphData();
  }

  loadGraphData = async () => {
    try {
      const { success, data } = await fetch(
        'https://us-central1-jyp-admin-saas.cloudfunctions.net/attendance/visualization',
      ).then(response => response.json());
      if (success) {
        this.setState({ graphsData: data, graphsDataLoaded: true });
      } else {
        this.setState({ graphsDataLoaded: true, graphsData: null });
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      this.setState({ graphsDataLoaded: true, graphsData: null });
    }
  };

  render() {
    if (!this.state.graphsDataLoaded) {
      return <Loader />;
    }

    if (!this.state.graphsData) {
      return (
        <Typography variant="subheading" color="error">
          Graph is not available
        </Typography>
      );
    }

    return (
      <GraphsContainer>
        {this.state.graphsData.map((graph) => {
          const {
            id, type, colSpan, ...config
          } = graph;
          return (
            <GraphContainer key={graph.id} fullWidth={colSpan === 2}>
              {type === 'BAR' ? (
                <BarGraph config={config} />
              ) : type === 'PIE' ? (
                <PieChart config={config} />
              ) : null}
            </GraphContainer>
          );
        })}
      </GraphsContainer>
    );
  }
}

export default AttendanceVisualization;

const GraphsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
`;

const GraphContainer = styled.div`
  ${props => props.fullWidth
    && css`
      grid-column-start: 1;
      grid-column-end: 3;
    `};
`;



// WEBPACK FOOTER //
// ./src/pages/AttendanceReport/components/AttendanceVisualization.js